import { render } from "./StreamsManageAudience.vue?vue&type=template&id=16735f08"
import script from "./StreamsManageAudience.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsManageAudience.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/StreamsDash/StreamsManageAudience.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16735f08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16735f08', __exports__)) {
    api.reload('16735f08', __exports__)
  }
  
  module.hot.accept("./StreamsManageAudience.vue?vue&type=template&id=16735f08", () => {
    api.rerender('16735f08', render)
  })

}


export default __exports__